import { getters } from "@/constants/state";

export default {
  [getters.SCHEDULEDT_GETTER]: (state) => state.schedulesDt,
};
